"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SessionStorage_1 = __importDefault(require("./SessionStorage"));
var InMemoryStorage_1 = __importDefault(require("./InMemoryStorage"));
var wwStorage = /** @class */ (function () {
    function wwStorage(runtime) {
        if (runtime === void 0) { runtime = false; }
        this.getStorage = function () { return wwStorage.sessionStorage; };
        try {
            if (!runtime) {
                wwStorage.sessionStorage = new SessionStorage_1.default(window.sessionStorage);
            }
            else {
                wwStorage.sessionStorage = new InMemoryStorage_1.default();
            }
        }
        catch (e) {
            wwStorage.sessionStorage = new InMemoryStorage_1.default();
        }
    }
    return wwStorage;
}());
exports.default = wwStorage;
